import "./hero.css";
import { useEffect, useState } from "react";
import { doc, onSnapshot } from "firebase/firestore";
import { db } from "../firebase/config";

export default function Hero() {

  // 🔥 DEFAULT DATA
  const defaultData = {
    name: "Prof. Dr. Kulkarni Martand Diwakarrao",
    subtitle: "Professor | Marathi Scholar | Academic Leader",
    image: "https://via.placeholder.com/300",
    primaryBtn: "View Profile",
    secondaryBtn: "Research Papers"
  };

  const [data, setData] = useState(defaultData);

  useEffect(() => {
    // ✅ 1. LOAD FROM CACHE FIRST (instant)
    const cached = localStorage.getItem("heroData");

    if (cached) {
      try {
        setData(JSON.parse(cached));
      } catch (e) {
        console.error("Cache parse error", e);
      }
    }

    // ✅ 2. REAL-TIME FIREBASE UPDATE
    const ref = doc(db, "siteContent", "hero");

    const unsubscribe = onSnapshot(ref, (snap) => {
      if (snap.exists()) {
        const freshData = snap.data();

        // 🔥 update UI
        setData(freshData);

        // 🔥 save to cache
        localStorage.setItem("heroData", JSON.stringify(freshData));
      }
    });

    return () => unsubscribe();
  }, []);

  return (
    <section className="hero">
      <div className="hero-container">

        {/* IMAGE */}
        <div className="hero-left">
          <img src={data.image} alt="profile" className="hero-img" />
        </div>

        {/* TEXT */}
        <div className="hero-right">
          <h1>{data.name}</h1>
          <p className="hero-sub">{data.subtitle}</p>

          <div className="hero-buttons">
            <button className="primary-btn">{data.primaryBtn}</button>
            <button className="secondary-btn">{data.secondaryBtn}</button>
          </div>
        </div>

      </div>
    </section>
  );
}